import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import LoggingConstants from 'sharedreact/constants/LoggingConstants';
import LogEntry from 'sharedreact/data/LogEntry';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import SettingsStore from 'sharedreact/stores/SettingsStore';

function toConsoleLevel (logLevel: string): 'debug' | 'info' | 'warn' | 'error' | 'debug' {
  switch (logLevel) {
    case LogEntry.LogLevel.trace:
    case LogEntry.LogLevel.debug:
      return 'debug';
    case LogEntry.LogLevel.info:
      return 'info';
    case LogEntry.LogLevel.warn:
      return 'warn';
    case LogEntry.LogLevel.error:
    case LogEntry.LogLevel.fatal:
      return 'error';
    default:
      return 'debug';
  }
}

function _logToConsole (consoleLogLevel: 'debug' | 'info' | 'warn' | 'error' | 'debug', message: Object): void {
  if ((window as any)['esko_logToConsole'] != null) {
    (window as any)['esko_logToConsole'](consoleLogLevel, message);
  } else {
    console[consoleLogLevel](message);
  }
}

const Content: {
} = {
};

class State extends Immutable.Record(Content) {
}

class LoggingStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  logToConsole (logLevel: string, logEntry: LogEntry, logRawData: boolean): void {
    if (LogEntry.getLogLevelIndex(logEntry.logLevel) >= LogEntry.getLogLevelIndex(logLevel) || (window as any)['esko_alwaysLogToConsole']) {
      const consoleLevel: 'debug' | 'info' | 'warn' | 'error' | 'debug' = toConsoleLevel(logLevel);
      _logToConsole(consoleLevel, logRawData ? logEntry.details : logEntry.message);
    }
  }

  override reduce (state: State, action: ActionType): State {
    const logToConsole: boolean = SettingsStore.getSettings().logToConsole;
    const logRawData: boolean = SettingsStore.getSettings().logRawData;
    const logLevel: string = SettingsStore.getSettings().logLevel;
    const logActions: boolean = SettingsStore.getSettings().logActions;
    const logServerCalls: boolean = SettingsStore.getSettings().logServerCalls;
    const logEvents: boolean = SettingsStore.getSettings().logEvents;
    const logHeartBeatEvents: boolean = SettingsStore.getSettings().logHeartBeatEvents;

    let didLogToConsole: boolean = false;

    switch (action.actionType) {
      case LoggingConstants.LOG: {
        if ((window as any)['esko_alwaysLogToConsole']) {
          this.logToConsole(action.logLevel, action.logEntry, logRawData);
          didLogToConsole = true;
        }

        if (LogEntry.getLogLevelIndex(action.logEntry.logLevel) >= LogEntry.getLogLevelIndex(logLevel)) {
          // check is event
          let shouldLog: boolean = true;
          if (action.logEntry.type === 'event') {
            if (action.logEntry.details.name === 'heartbeat') {
              shouldLog = logEvents && logHeartBeatEvents;
            } else {
              shouldLog = logEvents;
            }
          } else if (action.logEntry.type === 'get' || action.logEntry.type === 'post' || action.logEntry.type === 'upload') {
            shouldLog = logServerCalls;
          }

          if (shouldLog) {
            if (!didLogToConsole && logToConsole) {
              this.logToConsole(action.logLevel, action.logEntry, logRawData);
            }
          }
        }
        return state;
      }
    }

    if (action.actionType !== 'UPDATE_SERVER_LOG') {
      const logEntry = LogEntry.createFromAction(action);

      if ((window as any)['esko_alwaysLogToConsole']) {
        this.logToConsole(action.logLevel, logEntry, logRawData);
        didLogToConsole = true;
      }

      if (logActions && LogEntry.getLogLevelIndex(action.logLevel) >= LogEntry.getLogLevelIndex(logLevel)) {
        if (!didLogToConsole && logToConsole) {
          this.logToConsole(action.logLevel, logEntry, logRawData);
        }
      }
    }

    return state;
  }
}

export default new LoggingStore();
